import React, { memo, useEffect, useState } from "react";

import { prefersReducedMotion } from "services/hooks/useSceneClock";
import { ShowcaseBackdrop } from "ui/components/Showcase";
import Logo from "ui/modules/public/components/Logo/Logo";

// Cesta je zasad isključena (previše uz slajdove) — vrati import i <LoginRoad /> ispod.
// import LoginRoad from "./components/LoginRoad/LoginRoad";
import LoginShowcase from "./components/LoginShowcase/LoginShowcase";
import {
  LOGIN_INTRO_LOGO_CENTERED,
  LOGIN_INTRO_LOGO_DOCKED,
  LOGIN_INTRO_TIMING,
} from "./consts";

const LoginIntro: React.FC = () => {
  // Bez animacija uvod se preskače: logo je odmah u kutu, a slajdovi na svom mjestu.
  const [showLogo, setShowLogo] = useState<boolean>(prefersReducedMotion);
  const [isLogoDocked, setIsLogoDocked] = useState<boolean>(prefersReducedMotion);
  const [showScene, setShowScene] = useState<boolean>(prefersReducedMotion);

  useEffect(() => {
    if (showScene) return;

    const logoTimer = setTimeout(() => setShowLogo(true), LOGIN_INTRO_TIMING.logo);
    const dockTimer = setTimeout(() => setIsLogoDocked(true), LOGIN_INTRO_TIMING.dock);
    const sceneTimer = setTimeout(() => setShowScene(true), LOGIN_INTRO_TIMING.scene);

    return () => {
      clearTimeout(logoTimer);
      clearTimeout(dockTimer);
      clearTimeout(sceneTimer);
    };
  }, []);

  return (
    <div className="hidden lg:flex w-1/2 bg-blue-700 h-screen flex-col relative overflow-hidden">
      <ShowcaseBackdrop />

      {/* Cesta odlazi zajedno s logom, pa scena ulazi na čistu pozadinu.
      <LoginRoad isLeaving={isLogoDocked} />
      */}

      {/* Logo kreće uvećan iz sredine panela i klizi u gornji lijevi kut. */}
      <div
        className="absolute top-8 left-8 z-10 will-change-transform transition-transform duration-1000 ease-[cubic-bezier(0.65,0,0.35,1)]"
        style={{ transform: isLogoDocked ? LOGIN_INTRO_LOGO_DOCKED : LOGIN_INTRO_LOGO_CENTERED }}
      >
        {/* Logo se montira tek nakon ceste, pa se njegova ulazna animacija vidi. */}
        {showLogo && <Logo variant="light" animated />}
      </div>

      {/* Na kraju uvoda ulaze slajdovi — s naslovom, opisom i točkicama na dnu panela. */}
      <div className="relative flex flex-col flex-1">
        {showScene && <LoginShowcase />}
      </div>
    </div>
  );
};

export default memo(LoginIntro);
